function initializeCollapsibles() {
  const collapsibles = document.querySelectorAll(".customCollapsible");

  if (collapsibles.length === 0) {
    return;
  }

  collapsibles.forEach((collapsible) => {
    // Remove any existing click listeners to prevent duplicates
    const newCollapsible = collapsible.cloneNode(true);
    collapsible.parentNode.replaceChild(newCollapsible, collapsible);
  });

  // Re-query after cloning
  const newCollapsibles = document.querySelectorAll(".customCollapsible");

  newCollapsibles.forEach((collapsible) => {
    collapsible.addEventListener("click", function () {
      newCollapsibles.forEach((otherCollapsible) => {
        if (otherCollapsible !== this) {
          otherCollapsible.classList.remove("active");
          const otherContent = otherCollapsible.nextElementSibling;
          if (otherContent) {
            otherContent.style.maxHeight = null;
            otherContent.classList.remove("open");
          }
        }
      });

      this.classList.toggle("active");
      const content = this.nextElementSibling;

      if (content) {
        if (content.style.maxHeight) {
          content.style.maxHeight = null;
          content.classList.remove("open");
        } else {
          content.style.maxHeight = content.scrollHeight + 30 + "px";
          content.classList.add("open");
        }
      }
    });
  });
}

// Handle both scenarios: DOM already loaded or still loading
if (document.readyState === 'loading') {
  document.addEventListener("DOMContentLoaded", initializeCollapsibles);
} else {
  initializeCollapsibles();
}

function initializeReadMore() {
  const description = document.querySelector(
    ".product__description.rte.quick-add-hidden"
  );

  if (!description) return;

  // Check if already initialized
  if (description.dataset.readmoreInitialized) return;
  description.dataset.readmoreInitialized = "true";

  description.style.transition = "max-height 0.3s ease-out";
  description.style.maxHeight = "80px";
  description.style.overflow = "hidden";

  const readMoreLink = document.createElement("a");
  readMoreLink.href = "#";
  readMoreLink.textContent = "...more";
  readMoreLink.classList.add("productDescReadMore");
  readMoreLink.style.cursor = "pointer";
  readMoreLink.style.display = "inline-block";
  readMoreLink.style.marginTop = "8px";

  description.insertAdjacentElement("afterend", readMoreLink);

  let isExpanded = false;
  readMoreLink.addEventListener("click", function (e) {
    e.preventDefault();
    isExpanded = !isExpanded;

    if (isExpanded) {
      description.style.maxHeight = description.scrollHeight + "px";
      readMoreLink.textContent = "Less";
    } else {
      description.style.maxHeight = "80px";
      readMoreLink.textContent = "...more";
    }
  });
}

if (document.readyState === 'loading') {
  document.addEventListener("DOMContentLoaded", initializeReadMore);
} else {
  initializeReadMore();
}

function initializeVariantContainer() {
  const variantSelects = document.querySelector("variant-selects");
  const quantity = document.querySelector(".product-form__quantity");

  if (variantSelects && quantity) {
    // Check if already wrapped
    if (variantSelects.parentElement?.classList.contains("newContainer")) {
      return;
    }

    const newContainer = document.createElement("div");
    newContainer.classList.add("newContainer");
    newContainer.appendChild(variantSelects);
    newContainer.appendChild(quantity);

    const collapsibleContainer = document.querySelector(
      ".collapsibleContainer"
    );

    if (collapsibleContainer) {
      collapsibleContainer.parentNode.insertBefore(
        newContainer,
        collapsibleContainer.nextSibling
      );
    }
  }
}

if (document.readyState === 'loading') {
  document.addEventListener("DOMContentLoaded", initializeVariantContainer);
} else {
  initializeVariantContainer();
}

function initializeSelectPlaceholders() {
  const selectElements = document.querySelectorAll(".select__select");

  selectElements.forEach(function (selectElement) {
    if (selectElement) {
      const optionLabel = selectElement
        .closest(".product-form__input--dropdown")
        ?.querySelector(".form__label");
      const optionName = optionLabel
        ? optionLabel.textContent.trim()
        : "option";

      // Check if placeholder already exists to avoid duplicates
      const existingPlaceholder =
        selectElement.querySelector('option[value=""]');
      if (!existingPlaceholder) {
        const placeholderOption = document.createElement("option");
        placeholderOption.textContent = `Choose ${optionName}`;
        placeholderOption.value = "";
        placeholderOption.disabled = true;
        placeholderOption.selected = true;

        selectElement.insertBefore(placeholderOption, selectElement.firstChild);
      }
    }
  });
}

if (document.readyState === 'loading') {
  document.addEventListener("DOMContentLoaded", initializeSelectPlaceholders);
} else {
  initializeSelectPlaceholders();
}
